<template>
  <q-page class="flex column home page-layout">
    <div class="grid-container-5-columns">
      <section class="grid-container-5-columns__item--full-row">
        <q-card flat class="filter-card">
          <q-card-section class="filter-card__section">
            <ThePlayerSelector v-on:updateFilter="handleFilterUpdate($event)" />
          </q-card-section>
        </q-card>
      </section>
      <section class="grid-container-5-columns__item--full-row">
        <q-card flat class="table-card">
          <q-card-section class="table-card__section">
            <ThePlayerSearchOverview :filter="filterOption" />
          </q-card-section>
        </q-card>
      </section>
    </div>
  </q-page>
</template>

<script>
import ThePlayerSelector from "@/components/filters/ThePlayerSelector.vue";
import ThePlayerSearchOverview from "@/views/player/PlayerSearchOverview.vue";

export default {
  name: "PlayerSearch",
  data() {
    return {
      filterOption: {
        siteId: 0,
        networkId: 0,
        operatorId: 0,
        playerId: 0,
      },
    };
  },
  components: {
    ThePlayerSelector,
    ThePlayerSearchOverview,
  },

  methods: {
    handleFilterUpdate: function(filterOption) {
      this.filterOption = filterOption;
    },
  },
};
</script>
